import { Route, Routes } from 'react-router-dom';
import Refinance from './Refinance';
import IncomeDetail from './IncomeDetail';
import YourRefinanceDetail from './PrimaryDetail';
import RefinanceApplicationSummary from './RefinanceApplicationSummary';

export const RefinanceRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Refinance />} />
      <Route path="summary/:id" element={<RefinanceApplicationSummary />} />
      <Route
        path="step/primary-detail/:id?"
        element={<YourRefinanceDetail />}
      />
      <Route
        path="step/income-detail/:id/:update?"
        element={<IncomeDetail />}
      />
    </Routes>
  );
};
